import { find, flatten } from "lodash";
import InstallmentDto from "../../PaymentContainerClient/dtos/InstallmentDto";
import PaymentRequestDto from "../../PaymentContainerClient/dtos/PaymentRequestDto";

export default function getInstallmentById(
    installmentId: string,
    paymentRequest: PaymentRequestDto
): InstallmentDto {
    return find(
        flatten(
            paymentRequest.availablePaymentPlans.map(
                (paymentPlan) => paymentPlan.installments
            )
        ),
        { id: installmentId }
    )!;
}
